import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { CookiesProvider } from "react-cookie";
import { Redirect, BrowserRouter as Router, Switch, useLocation, withRouter } from "react-router-dom";

import store from "./store/configStore";
import i18n from "./localization/i18n";
import Auth from "./layouts/Auth";
import AuthRoute from "./router/AuthRoute";
import User from "./layouts/User";
import Public from "./layouts/Public";
import Admin from "./layouts/Admin";
import AppContainer from "layouts/AppContainer";
import "./App.css";
import PrivateRoute from "./router/PrivateRoute";
import PublicRoute from "./router/PublicRoute";
import AppUtil from "utilities/AppUtil";
// import ScrollToTop from "./components/Common/ScrollToTop";
import history from "router/history";

const App = () => {

  const _ScrollToTop = ({ children }) => {
    const { pathname } = useLocation();
    useEffect(() => {
      const mainPanel = document.getElementById('main-panel');
      if (!mainPanel) {
        window.scrollTo(0, 0);
      } else {
        if (AppUtil.detectBrowser() === "Firefox") {
          mainPanel.scrollTop = 0;
        } else {
          mainPanel.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      }
    }, [pathname]);
    return children
  };

  const ScrollToTop = withRouter(_ScrollToTop);

  return (
    <CookiesProvider>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <AppContainer>
            <Router history={history}>
              <ScrollToTop>
                <Switch>
                  <AuthRoute path="/auth" component={Auth} />
                  <PrivateRoute path="/admin" component={Admin} />
                  <PublicRoute path="/public" component={Public} />
                  <PrivateRoute path="/" component={User} />
                  <Redirect to="/auth/company/login" />
                </Switch>
              </ScrollToTop>
            </Router>
          </AppContainer>
        </I18nextProvider>
      </Provider>
    </CookiesProvider>
  );
};

export default App;
